import { createContext, useState } from 'react';

const EarlyAccessContext = createContext();

export const EarlyAccessProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <EarlyAccessContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </EarlyAccessContext.Provider>
  );
};

export default EarlyAccessContext;
